require('./bootstrap');
require('./alert')
require('./color')
require('./popover')
require('./swiper')
require('./product')
require('./cart-page')
require('./form-mask')
require('./filter')

import Collapse from 'bootstrap/js/dist/collapse'

/*/
 * Blá blá blá
/*/
	function doubleTrouble() {
		if (event.key === 'Control') {
			siteCtrlClicks++
			if (siteCtrlClicks >= 2) {
				confirm('Feito com 💖 para o Rosinha! \n 👨🏼‍🎨 Front-end developer :: https://rcrdk.dev')
			}
			setTimeout(() => (siteCtrlClicks = 0), 200)
		}
	}

	let siteCtrlClicks = 0
	document.addEventListener('keyup', doubleTrouble, true)
